import { render, staticRenderFns } from "./schema-select.vue?vue&type=template&id=eb0fecca"
import script from "./schema-select.vue?vue&type=script&lang=js"
export * from "./schema-select.vue?vue&type=script&lang=js"
import style0 from "./schema-select.vue?vue&type=style&index=0&id=eb0fecca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports